import React from 'react';

import Accordion from 'components/Accordion';
import { PreferenceList } from 'services/api/Meteorology';
import Preference from './Preference';

interface PreferencesAccordionProps {
  preferenceList: PreferenceList[],
  deleteTrigger: ({ id }: { id: number }) => void,
  deleteLoading: boolean,
}

export default function PreferencesAccordion({
  preferenceList,
  deleteTrigger,
  deleteLoading,
}: PreferencesAccordionProps) {
  return (
    <Accordion.Item eventKey="0">
      <Accordion.Header>Preferências Salvas</Accordion.Header>
      <Accordion.Body>
        { preferenceList.map((preference) => (
          <Preference
            key={preference.id}
            preference={preference}
            onDelete={deleteTrigger}
            deleteLoading={deleteLoading}
          />
        )) }
      </Accordion.Body>
    </Accordion.Item>
  );
}
